import React, { Component } from 'react'
import { PanelGroup } from 'react-bootstrap'
import MigrationKeyPanel from './MigrationKeyPanel'

class ElementorFAQs extends Component{
	constructor(props){
		super(props)
		this.state = {}
		this.handleFAQSelect = this.handleFAQSelect.bind(this)
	}

	handleFAQSelect(activeFAQKey) {
		let _key = this.state.activeFAQKey
		if (_key && _key == activeFAQKey) {
			this.setState({ activeFAQKey: false })
		} else {
			this.setState({ activeFAQKey: activeFAQKey })
		}
	}

	render(){
		const { bvKeyMigrationEnabled } = this.props
		const { activeFAQKey } = this.state
		return (
			<div>
				<PanelGroup
					activeKey={activeFAQKey}
					onSelect={this.handleFAQSelect}
					bsClass="col-xs-10 col-md-10 bv-faq-accordion-list"
					accordion
					id="elementor"
				>
					{bvKeyMigrationEnabled ? <MigrationKeyPanel eventKey='1' activeFAQKey={activeFAQKey} /> : null}
				</PanelGroup>
			</div>
		)
	}
}

export default ElementorFAQs
